import { Quote } from "lucide-react";

const reviews = [
  {
    name: "rkaayx",
    quote: "Helped me all the way, really quick response.",
  },
  {
    name: "chiffon2332",
    quote: "Really insane. Best out on the market.",
  },
  {
    name: "dbdnala",
    quote: "Really good. Highly recommended.",
  },
];

const Reviews = () => {
  return (
    <section data-testid="reviews-section" className="py-24 px-6 border-b border-red-500/20">
      <div className="max-w-6xl mx-auto">
        <div className="mb-14 text-center">
          <p className="font-mono-x text-xs text-[#ff4655] uppercase tracking-widest mb-1">Community Feedback</p>
          <h2 className="font-display text-5xl uppercase text-white">From Our Discord</h2>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {reviews.map((r, i) => (
            <figure
              key={r.name}
              data-testid={`review-card-${i}`}
              className="p-6 bg-zinc-900/60 border-l-2 border-[#ff4655] hover:bg-zinc-900 transition-colors"
            >
              <Quote className="w-5 h-5 text-[#ff4655] mb-4" />
              <blockquote className="text-zinc-200 text-sm leading-relaxed mb-5">
                “{r.quote}”
              </blockquote>
              <figcaption className="flex items-center gap-2">
                <span className="w-6 h-6 bg-[#180e12] border border-[#ff4655]/50 flex items-center justify-center font-display text-[10px] text-[#ff4655] uppercase">
                  {r.name.charAt(0)}
                </span>
                <span className="font-mono-x text-xs text-zinc-400">{r.name}</span>
                <span className="font-mono-x text-[9px] uppercase tracking-widest text-zinc-600 ml-auto">
                  Discord member
                </span>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Reviews;
